import React, { useEffect, useState } from "react";
import { FaSeedling } from "react-icons/fa";
import getDomain from "utils/getDomain";
import { inciAkuDomains } from "constants/moduleConstants/domain.constant";
import {
  INCI_AKU_TRACK_SEED_URL,
  dismissInciAkuSeedBanner,
  isInciAkuSeedBannerVisible,
  subscribeInciAkuSeedBanner,
} from "utils/inciAkuSeedBanner";

const InciAkuSeedTrackBanner = () => {
  const [visible, setVisible] = useState(() => isInciAkuSeedBannerVisible());
  const isInciAku = inciAkuDomains.includes(getDomain().toLowerCase());

  useEffect(() => {
    return subscribeInciAkuSeedBanner(() => {
      setVisible(isInciAkuSeedBannerVisible());
    });
  }, []);

  if (!isInciAku || !visible) {
    return null;
  }

  const handleTrackClick = () => {
    window.open(INCI_AKU_TRACK_SEED_URL, "_blank", "noopener,noreferrer");
    dismissInciAkuSeedBanner();
  };

  return (
    <div className="flex items-center justify-between gap-2.5 w-full text-xs bg-[#007D72] text-white p-1.5">
      <span>
        Tohum topu bağışınızı tamamlamak için buraya tıklayabilirsiniz.
      </span>
      <button
        type="button"
        className="shrink-0 inline-flex items-center gap-1.5 font-semibold underline underline-offset-2 hover:text-[#A0EB83]"
        onClick={handleTrackClick}
      >
        Tohum Bağışla
        <FaSeedling />
      </button>
    </div>
  );
};

export default InciAkuSeedTrackBanner;
